import React from "react";
import { Row, Col, Button } from "antd";
import { AvailableFilter } from "../index";
import FilterItem from "./FilterItem/FilterItem";
import styles from "./style.module.scss";

export interface TableFiltersProps {
  availableFilters: AvailableFilter[];
  filters: Record<string, string[] | null>;
  onTableFilterChange: (filters: Record<string, string[] | null>) => void;
  /**
   * Class on each filter's dropdown (and the calendar a date filter opens). Those render
   * at the document root, so a host on a surface of their colour - a modal - styles
   * them through this.
   */
  dropdownClassName?: string;
}

function TableFilters({
  availableFilters,
  filters,
  onTableFilterChange,
  dropdownClassName,
}: TableFiltersProps) {
  const handleFilterChange = (filterKey: string, values: string[] | null) => {
    const newFilters = {
      ...filters,
      [filterKey]: values,
    };
    onTableFilterChange(newFilters);
  };

  const handleClearSelection = () => {
    const clearedFilters: Record<string, string[] | null> = {};
    availableFilters.forEach((filter) => {
      clearedFilters[filter.key] = null;
    });
    onTableFilterChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters).some(
    (filterValues) => filterValues && filterValues.length > 0,
  );

  return (
    <div className={styles.filtersContainer}>
      <Row gutter={[8, 8]} align="middle">
        {availableFilters.map((filter) => (
          <Col key={filter.key}>
            <FilterItem
              filter={filter}
              selectedValues={filters[filter.key] || []}
              onFilterChange={handleFilterChange}
              dropdownClassName={dropdownClassName}
            />
          </Col>
        ))}
        {hasActiveFilters && (
          <Col>
            <Button type="link" size="small" onClick={handleClearSelection}>
              Reset
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default TableFilters;
